if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });

      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

      // Add event listeners for the next/prev buttons
      this.nextButton = this.querySelector('.new-next-button-slide');
      this.prevButton = this.querySelector('.new-prev-button-slide');
      if (this.nextButton && this.prevButton) {
        this.nextButton.addEventListener('click', this.goToNextMedia.bind(this));
        this.prevButton.addEventListener('click', this.goToPrevMedia.bind(this));
      }

      // Ensure the first thumbnail is active at initialization
      this.setActiveThumbnail(this.elements.thumbnails.querySelector('[data-target]'));
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

  setActiveThumbnail(thumbnailLi) {
  if (!this.elements.thumbnails || !thumbnailLi) {
    console.log("No thumbnail found to set active.");
    return;
  }

  // Remove aria-current from all buttons
  this.elements.thumbnails.querySelectorAll('button').forEach((btn) => btn.removeAttribute('aria-current'));

  // Find the button inside the new active <li> and set aria-current="true"
  const newActiveButton = thumbnailLi.querySelector('button');
  if (newActiveButton) {
    newActiveButton.setAttribute('aria-current', "true");
    console.log(`Set aria-current="true" on: ${thumbnailLi.id}`);
  }

  // **Fix: Stop slider from auto-scrolling**
  this.elements.thumbnails.scrollLeft = 0; // Resets any unwanted scroll movement
}


    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    // Navigation Functions

goToNextMedia() {
  const activeLi = this.elements.thumbnails.querySelector('button[aria-current="true"]')?.closest('li');
  if (!activeLi) {
    console.log("No active thumbnail found.");
    return;
  }

  let nextLi = activeLi.nextElementSibling;
  if (!nextLi) {
    console.log("Reached last thumbnail. Stopping navigation.");
    return; // Stop if there's no next item
  }

  console.log(`Moving to next thumbnail: ${nextLi.id}`);
  this.setActiveThumbnail(nextLi);

  // Update active media
  const mediaId = nextLi.dataset.target;
  this.setActiveMedia(mediaId, false);
}

goToPrevMedia() {
  const activeLi = this.elements.thumbnails.querySelector('button[aria-current="true"]')?.closest('li');
  if (!activeLi) {
    console.log("No active thumbnail found.");
    return;
  }

  let prevLi = activeLi.previousElementSibling;
  if (!prevLi) {
    console.log("Reached first thumbnail. Stopping navigation.");
    return; // Stop if there's no previous item
  }

  console.log(`Moving to previous thumbnail: ${prevLi.id}`);
  this.setActiveThumbnail(prevLi);

  // Update active media
  const mediaId = prevLi.dataset.target;
  this.setActiveMedia(mediaId, false);
}


  });
}

// Prevent default behavior of buttons
document.querySelectorAll('.new-next-button-slide, .new-prev-button-slide').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    console.log(`Button clicked: ${event.target.className}`);
  });
});
